import take from 'lodash/take'
import React from 'react'

import { ProductSlider } from '@Domains/Product/Features/ProductSlider/ProductSlider'
import { useProductTactics } from '@Domains/Product/Features/Tactics/Hook'
import { Product } from '@Generated/graphql'

export const RecommendationSlider = ({
  group,
  id,
  productID,
}: {
  group: Exclude<keyof NonNullable<Product['tactics']>, '__typename'>
  id: string
  productID: string
}) => {
  const [ref, loading, tactics] = useProductTactics(productID, group)

  if (loading) {
    return (
      <ProductSlider
        header={' '}
        loading={loading}
        products={[]}
        wrapperRef={ref}
      />
    )
  }

  const tactic = tactics?.find(i => 'id' in i && i.id === id)
  const recommendation = ((tactic as any)?.recommendations || [])?.[0]

  if (!recommendation?.products || recommendation.products.length === 0) {
    return null
  }

  const sourceID = `product_page_${recommendation.placement}_${recommendation.id}`

  return (
    <ProductSlider
      data-in-view={id}
      header={recommendation.title}
      loading={false}
      products={take(recommendation.products, 18)}
      sourceID={sourceID}
      wrapperRef={ref}
    />
  )
}
